import * as React from 'react';
import CertaMenu from 'components/menu';
import { Menu, Responsive, Sidebar } from 'semantic-ui-react';

import './styles.css';

export interface Props {
  mobileMenuVisible: boolean;
}

// tslint:disable-next-line:no-any
export class MenuWrapper extends React.Component<Props, any> {

  public render() {
      return (
          <div className="main-content">
            <Responsive minWidth={Responsive.onlyTablet.minWidth} as={React.Fragment} >
              <Menu className="menu-content no-border-radius" vertical={true} size="large" floated={true}>
                <CertaMenu />
              </Menu>
              {this.props.children}
            </Responsive>
            <Responsive {...Responsive.onlyMobile} as={React.Fragment}>
              <Sidebar.Pushable>
                <Sidebar
                  className="menu-content no-border-radius mobile-menu"
                  as={Menu}
                  animation="overlay"
                  vertical={true}
                  visible={this.props.mobileMenuVisible}
                  size="large"
                >
                  <CertaMenu />                  
                </Sidebar>
                <Sidebar.Pusher dimmed={this.props.mobileMenuVisible}>
                  {this.props.children}
                </Sidebar.Pusher>
              </Sidebar.Pushable>
            </Responsive>
          </div>
      );
  }
}


// WEBPACK FOOTER //
// ./src/components/menu-wrapper/component.tsx